import * as React from "react";
import { useDispatch } from "react-redux";
import { Avatar, Box, Button, Card, CardActions, CardContent, Typography } from "@mui/material";

import useRcSps from "../../../common/hooks/useRcSp";
import AppointmentDialog from "./appointment-dialog";
import { doctorImgLink } from "../../../../constants";
import Spinner from "../../../common/components/spinner";
import { setSelectedSp } from "../../../../slices/clientPortalUserInfoSlice";
import { Specialities } from "../../../../models/ResourceCentreServiceProvider";
import { ServiceProvider } from "../../../../interfaces/ServiceProvidersInterface";

// @ts-expect-error - css
import styles from "./appointments.module.scss";

const ServiceProviderSelect = (): React.JSX.Element => {
  const dispatch = useDispatch();
  const { rcSps: serviceProviders, isLoading } = useRcSps();
  const [openBookingDialog, setOpenBookingDialog] = React.useState(false);

  const handleSelectSp = (sp: ServiceProvider) => {
    dispatch(setSelectedSp(sp));
  };

  if (isLoading) {
    return <Spinner />;
  }

  return (
    <Box>
      <AppointmentDialog
        open={openBookingDialog}
        onClose={() => {
          setOpenBookingDialog(false);
          dispatch(setSelectedSp(null));
        }}
      />

      <Button
        variant="contained"
        size="large"
        className={styles.bookButton}
        onClick={() => setOpenBookingDialog(true)}
      >
        <Typography>Book Appointment</Typography>
      </Button>
      <div className={styles.spContainer}>
        {serviceProviders
          .filter((sp) => sp.active)
          .map((sp) => (
            <Card key={sp.id} className={styles.card}>
              <Avatar
                className={styles.avatar}
                src={sp?.serviceProviderDetails?.profileImage || doctorImgLink}
                alt={sp.firstName}
              />
              <CardContent className={styles.cardContent}>
                <Typography variant="h6">{`${sp.title || ""} ${sp.firstName} ${
                  sp.lastName
                }`}</Typography>
                <Typography>
                  {sp?.specialities?.length > 0
                    ? Specialities[sp.specialities[0] as keyof typeof Specialities]
                    : ""}
                </Typography>
              </CardContent>
              <CardActions className={styles.cardActions}>
                <Button
                  size="large"
                  className={styles.bookButton}
                  onClick={() => {
                    handleSelectSp(sp);
                    setOpenBookingDialog(true);
                    // setOpenAvailabilityDialog(true);
                  }}
                >
                  <Typography>Book Appointment</Typography>
                </Button>
              </CardActions>
            </Card>
          ))}
      </div>
    </Box>
  );
};

export default ServiceProviderSelect;
